import { ConfigItem } from 'Core/interfaces'
import { ConfigFilterItem } from 'Core/interfaces/filters'

export enum AdjustmentsFields {
	Id = 'id',
	OriginalCustomerInvoiceId = 'originalCustomerInvoiceId',
	TotalInvoiceAmount = 'totalInvoiceAmount',
	Currency = 'currency',
	OriginalInvoiceTotalAmount = 'originalInvoiceTotalAmount',
	OriginalInvoiceCurrency = 'originalInvoiceCurrency',
	InternalComments = 'internalComments',
	OriginalInvoiceInternalComments = 'originalInvoiceInternalComments',
	InvoiceDate = 'invoiceDate',
	Status = 'status',
	InvoiceType = 'invoiceType',
	Number = 'number',
	CustomBillingFrequencyCode = 'customBillingFrequencyCode',
	PoNumber = 'poNumber',
	BillingAgency = 'billingAgency',
	AdjustmentReason = 'adjustmentReason',
	BillingItemIds = 'billingItemIds',
	InvoiceAdjustmentTypeCode = 'invoiceAdjustmentTypeCode',
	OriginalInvoice = 'originalInvoice',
	OriginalInvoiceId = 'originalInvoiceId',
	AdjustmentReasonId = 'adjustmentReasonId',
	ItemDescription = 'itemDescription',
	Quantity = 'quantity',
	UnitOfMeasure = 'unitOfMeasure',
	UnitPrice = 'unitPrice',
	ExtendedPrice = 'extendedPrice',
	InvoiceComments = 'invoiceComments',
	ServiceOccurrenceId = 'serviceOccurrenceId',
	TotalPrice = 'totalPrice',
	ServiceDate = 'serviceDate',
	ItemRef = 'itemRef',
	UnitOfMeasureId = 'unitOfMeasureId',
	Items = 'items',
	IsProceed = 'isProceed',
	IsBackOut = 'isBackOut',
	IsNonBillable = 'isNonBillable',
	UpdateUser = 'updateUser',
	isRebill = 'isRebill',
	invoiceType = 'invoiceType'
}

export enum AdjustmentSearchFields {
	searchResultByOriginalInvoiceId = 'searchResultByOriginalInvoiceId',
	searchResultByUser = 'searchResultByUser'
}

export enum AdjustmentFilterFields {
	invoiceDateFrom = 'invoiceDateFrom',
	invoiceDateTo = 'invoiceDateTo',
	statusId = 'statusId'
}

export declare namespace Adjustment {
	interface Basic {
		[AdjustmentsFields.Id]: number
		[AdjustmentsFields.OriginalCustomerInvoiceId]: number | null
		[AdjustmentsFields.TotalInvoiceAmount]: number | null
		[AdjustmentsFields.Currency]: Entity | null
		[AdjustmentsFields.OriginalInvoiceTotalAmount]: number | null
		[AdjustmentsFields.OriginalInvoiceCurrency]: Entity | null
		[AdjustmentsFields.InternalComments]: BasicString
		[AdjustmentsFields.OriginalInvoiceInternalComments]: BasicString
		[AdjustmentsFields.InvoiceDate]: BasicString
		[AdjustmentsFields.UpdateUser]: Entity | null
		[AdjustmentsFields.Status]: Entity | null
		[AdjustmentsFields.InvoiceType]: Entity | null
		[AdjustmentsFields.isRebill]: boolean
		[AdjustmentsFields.invoiceType]: Entity | null
	}

	interface Details {
		[AdjustmentsFields.Id]: number
		[AdjustmentsFields.Number]: string
		[AdjustmentsFields.Status]: Entity
		[AdjustmentsFields.InvoiceType]: Entity
		[AdjustmentsFields.CustomBillingFrequencyCode]: Entity
		[AdjustmentsFields.PoNumber]: BasicString
		[AdjustmentsFields.BillingAgency]: Entity
		[AdjustmentsFields.AdjustmentReason]: CodeEntity
	}

	interface ExistingInvoices {
		[AdjustmentsFields.Id]: number
		[AdjustmentsFields.InvoiceDate]: BasicString
		[AdjustmentsFields.ItemDescription]: BasicString
		[AdjustmentsFields.Quantity]: number
		[AdjustmentsFields.UnitOfMeasure]: Entity
		[AdjustmentsFields.UnitPrice]: number
		[AdjustmentsFields.ExtendedPrice]: number
		[AdjustmentsFields.Status]: Entity
		[AdjustmentsFields.InvoiceComments]: BasicString
	}

	interface BillingItems {
		[AdjustmentsFields.Id]: number
		[AdjustmentsFields.ServiceOccurrenceId]: number
		[AdjustmentsFields.ItemDescription]: string
		[AdjustmentsFields.Quantity]: number
		[AdjustmentsFields.UnitOfMeasure]: Entity
		[AdjustmentsFields.TotalPrice]: number
		[AdjustmentsFields.ServiceDate]: BasicString
	}

	namespace Item {
		interface Basic {
			[AdjustmentsFields.Id]: number
			[AdjustmentsFields.ItemRef]: BasicString
			[AdjustmentsFields.ItemDescription]: string
			[AdjustmentsFields.Quantity]: number
			[AdjustmentsFields.UnitOfMeasure]: Entity
			[AdjustmentsFields.TotalPrice]: number
			[AdjustmentsFields.UnitPrice]: number
		}

		interface EditItem {
			[AdjustmentsFields.Id]: number
			[AdjustmentsFields.ItemRef]: BasicString
			[AdjustmentsFields.ItemDescription]: BasicString
			[AdjustmentsFields.Quantity]: number
			[AdjustmentsFields.UnitOfMeasureId]: number
			[AdjustmentsFields.TotalPrice]: number
			[AdjustmentsFields.UnitPrice]: number
			[AdjustmentsFields.Status]: BasicString
		}

		namespace Form {
			interface Edit {
				[AdjustmentsFields.Items]: EditItem[]
			}
		}

		namespace Request {
			interface Edit {
				[AdjustmentsFields.Id]: number
				[AdjustmentsFields.ItemRef]: BasicString
				[AdjustmentsFields.ItemDescription]: BasicString
				[AdjustmentsFields.Quantity]: number
				[AdjustmentsFields.UnitOfMeasureId]: number
				[AdjustmentsFields.TotalPrice]: number
				[AdjustmentsFields.UnitPrice]: number
				[AdjustmentsFields.IsProceed]: boolean
				[AdjustmentsFields.IsBackOut]: boolean
				[AdjustmentsFields.IsNonBillable]: boolean
			}
		}
	}

	namespace Search {
		interface Result {
			[AdjustmentSearchFields.searchResultByOriginalInvoiceId]: number[]
			[AdjustmentSearchFields.searchResultByUser]: Entity[]
		}

		interface Config {
			[AdjustmentSearchFields.searchResultByOriginalInvoiceId]: ConfigItem<AdjustmentSearchFields>
			[AdjustmentSearchFields.searchResultByUser]: ConfigItem<AdjustmentSearchFields>
		}
	}

	namespace Filter {
		interface Config {
			[AdjustmentFilterFields.invoiceDateFrom]: ConfigFilterItem<string, null>
			[AdjustmentFilterFields.invoiceDateTo]: ConfigFilterItem<string, null>
			[AdjustmentFilterFields.statusId]: ConfigFilterItem<string, string>
		}
	}

	namespace Form {
		interface Add {
			[AdjustmentsFields.BillingItemIds]: number[]
			[AdjustmentsFields.InvoiceAdjustmentTypeCode]: string
			[AdjustmentsFields.OriginalInvoice]: LabelValue<number> | null
			[AdjustmentsFields.AdjustmentReasonId]: number | null
		}
	}

	namespace Request {
		interface Add {
			[AdjustmentsFields.BillingItemIds]: number[]
			[AdjustmentsFields.InvoiceAdjustmentTypeCode]: string
			[AdjustmentsFields.OriginalInvoiceId]: number
			[AdjustmentsFields.AdjustmentReasonId]: number
		}
	}
}
